export default function onCorKey(e) {
	if (e.keyCode === 13 || e.keyCode === 32) return true;
	else return false;
}
